/**
 * Clock.ts — turns an absolute timestamp into per-frame delta seconds.
 * You pass `now` in, so it stays testable without the real wall clock.
 */
export class Clock {
  private last: number;

  constructor(now: number) {
    this.last = now;
  }

  /** Seconds elapsed since the previous tick. */
  tick(now: number): number {
    const dt = (now - this.last) / 1000;
    this.last = now;
    return dt;
  }

  /** Reset the reference time (used when resuming after a pause / tab-blur). */
  reset(now: number): void {
    this.last = now;
  }
}
